import roomData from "../join_pages/Room";
import homepageData from '../join_pages/Homepage';
import homepageSlideOutData from '../join_pages/HomepageSlideOut';
import roomsGrid from '../join_pages/RoomsGrid';
import roomsList from '../join_pages/RoomsList';
import roomLightsLoadsGrid from '../join_pages/RoomLightsLoadsGrid';
import roomLightsLoadsList from '../join_pages/RoomLightsLoadsList';
import roomLightsScenesGrid from '../join_pages/RoomLightScenesGrid';
import roomLightsScenesList from '../join_pages/RoomLightsScenesList';
import roomClimate from '../join_pages/RoomClimate';
import roomClimateScheduler from '../join_pages/RoomClimateScheduler';
import roomAudioMirage from '../join_pages/RoomAudioMirage';
import roomAudioSonosFavourites from '../join_pages/RoomAudioSonosFavourites';
import roomAudioSonosNowPlaying from '../join_pages/RoomAudioSonosNowPlaying';
import roomVideoAppleTv from '../join_pages/RoomVideoAppleTv';
import roomVideoBluray from '../join_pages/RoomVideoBluray';
import roomVideoCableDVR from '../join_pages/RoomVideoCableDVR';
import roomVideoCableKeypad from '../join_pages/RoomVideoCableKeypad';
import roomVideoCableRemote from '../join_pages/RoomVideoCableRemote';
import roomVideoKaleidescape from '../join_pages/RoomVideoKaleidescape';
import roomVideoMultiplexDual from '../join_pages/RoomVideoMultiplexDual';
import roomVideoMultiplexQuad from '../join_pages/RoomVideoMultiplexQuad';
import roomVideoMultiplexSingle from '../join_pages/RoomVideoMultiplexSingle';
import roomVideoRoku from '../join_pages/RoomVideoRoku';
import roomVideoText from '../join_pages/RoomVideoText';
import roomShadesScenesList from '../join_pages/RoomShadesScenesList';
import roomShadesScenesGrid from '../join_pages/RoomShadesScenesGrid';
import roomShadesLoadsGrid from '../join_pages/RoomShadesLoadsGrid';
import roomShadesLoadsList from '../join_pages/RoomShadesLoadsList';
import globalAudio from '../join_pages/GlobalAudio';
import globalClimate from '../join_pages/GlobalClimate';
import globalLights from '../join_pages/GlobalLights';
import globalShades from '../join_pages/GlobalShades';
import globalVideo from '../join_pages/GlobalVideo';
import securityCameras from '../join_pages/SecurityCameras';
import securitySystem from '../join_pages/SecuritySystem';
import securityZones from '../join_pages/SecurityZones';
import spa from '../join_pages/Spa';
import pool from '../join_pages/Pool';
import systems from '../join_pages/Systems';
import intercomData from '../join_pages/Intercom';
import { JoinData } from '../join_pages/JoinDataInt';
import allSignals from '../join_pages/AllPages';

export interface PageConfig {
    image: string;
    data: JoinData[];
    pageSignal?: string;
    type?: 'split' | 'combined'
}

const BASE_URL = 'https://ihclientstorage.blob.core.windows.net/images/clients/wgc/documentation';
const YEAR_MONTH = '2025-01';

const pageConfigs: Record<string, PageConfig> = {
    homepage: {
      image: `${BASE_URL}/Homepage_${YEAR_MONTH}.png`,
      pageSignal: '21',
      data: homepageData
    },
    homepageSlideOut: {
      image: `${BASE_URL}/Homepage_with_SlideOut_${YEAR_MONTH}.png`,
      pageSignal: '21',
      data: homepageSlideOutData
    },
    roomsGridView: {
      image: `${BASE_URL}/Rooms_GridView_${YEAR_MONTH}.png`,
      pageSignal: '22',
      data: roomsGrid
    },
    roomsListView: {
      image: `${BASE_URL}/Rooms_ListView_${YEAR_MONTH}.png`,
      pageSignal: '22',
      data: roomsList
    },
    room: {
      image: `${BASE_URL}/Room_${YEAR_MONTH}.png`,
      pageSignal: '30',
      data: roomData
    },
    roomLightsScenesGrid: {
      image: `${BASE_URL}/Room_Lights_Scenes_Grid_${YEAR_MONTH}.png`,
      pageSignal: '41 & 68 or 605 & 603',
      data: roomLightsScenesGrid
    },
    roomLightsScenesList: {
      image: `${BASE_URL}/Room_Lights_Scenes_List_${YEAR_MONTH}.png`,
      pageSignal: '41 & 68 or 605 & 603',
      data: roomLightsScenesList
    },
    roomLightsLoadsGrid: {
      image: `${BASE_URL}/Room_Lights_Loads_Grid_${YEAR_MONTH}.png`,
      pageSignal: '41 & 69 or 605 & 604',
      data: roomLightsLoadsGrid
    },
    roomLightsLoadsList: {
      image: `${BASE_URL}/Room_Lights_Loads_List_${YEAR_MONTH}.png`,
      pageSignal: '41 & 69 or 605 & 604',
      data: roomLightsLoadsList
    },
    roomClimate: {
      image: `${BASE_URL}/Room_Climate_${YEAR_MONTH}.png`,
      pageSignal: '43 or 561',
      data: roomClimate
    },
    roomClimateScheduler: {
      image: `${BASE_URL}/Room_Climate_Scheduler_${YEAR_MONTH}.png`,
      pageSignal: '43 & 170 or 561 & 170',
      data: roomClimateScheduler
    },
    roomAudioMirage: {
      image: `${BASE_URL}/Room_Audio_Mirage_${YEAR_MONTH}.png`,
      pageSignal: '44 & 256 or 569 & 576',
      data: roomAudioMirage
    },
    roomAudioSonosNowPlaying: {
      image: `${BASE_URL}/Room_Audio_Sonos_NowPlaying_${YEAR_MONTH}.png`,
      pageSignal: '44 & 264 or 569 & 584',
      data: roomAudioSonosNowPlaying
    },
    roomAudioSonosFavourites: {
      image: `${BASE_URL}/Room_Audio_Sonos_Favourites_${YEAR_MONTH}.png`,
      pageSignal: '44 & 264 or 569 & 584',
      data: roomAudioSonosFavourites
    },
    roomShadesScenesGrid: {
      image: `${BASE_URL}/Room_Shades_Scenes_Grid_${YEAR_MONTH}.png`,
      pageSignal: '42 & 77 or 615 & 613',
      data: roomShadesScenesGrid
    },
    roomShadesScenesList: {
      image: `${BASE_URL}/Room_Shades_Scenes_List_${YEAR_MONTH}.png`,
      pageSignal: '42 & 77 or 615 & 613',
      data: roomShadesScenesList
    },
    roomShadesLoadsGrid: {
      image: `${BASE_URL}/Room_Shades_Loads_Grid_${YEAR_MONTH}.png`,
      pageSignal: '42 & 77 or 615 & 614',
      data: roomShadesLoadsGrid
    },
    roomShadesLoadsList: {
      image: `${BASE_URL}/Room_Shades_Loads_List_${YEAR_MONTH}.png`,
      pageSignal: '42 & 77 or 615 & 614',
      data: roomShadesLoadsList
    },
    roomVideoAppleTV: {
      image: `${BASE_URL}/Room_Video_AppleTV_${YEAR_MONTH}.png`,
      pageSignal: '45 & 272 or 615 & 572',
      data: roomVideoAppleTv
    },
    roomVideoBluray: {
      image: `${BASE_URL}/Room_Video_Bluray_${YEAR_MONTH}.png`,
      pageSignal: '45 & 273 or 615 & 573',
      data: roomVideoBluray
    },
    roomVideoCableRemote: {
      image: `${BASE_URL}/Room_Video_Cable_Remote_${YEAR_MONTH}.png`,
      pageSignal: '45 & 271 & 290 or 615 & 571 & 290',
      data: roomVideoCableRemote
    },
    roomVideoCableKeypad: {
      image: `${BASE_URL}/Room_Video_Cable_Keypad_${YEAR_MONTH}.png`,
      pageSignal: '45 & 271 & 291 or 615 & 571 & 291',
      data: roomVideoCableKeypad
    },
    roomVideoCableDVR: {
      image: `${BASE_URL}/Room_Video_Cable_DVR_${YEAR_MONTH}.png`,
      pageSignal: '45 & 271 & 292 or 615 & 571 & 292',
      data: roomVideoCableDVR
    },
    // roomVideoCableFavorites: {
    //   image: `${BASE_URL}/Room_Video_Cable_Favorites_${YEAR_MONTH}.png`,
    //   pageSignal: '45 & 271 & 293 or 615 & 571 & 293',
    //   data: []
    // },
    roomVideoKaleidescape: {
      image: `${BASE_URL}/Room_Video_Kaleidescape_${YEAR_MONTH}.png`,
      pageSignal: '45 & 281 or 615 & 581',
      data: roomVideoKaleidescape
    },
    roomVideoMultiplexDual: {
      image: `${BASE_URL}/Room_Video_Multiplex_Dual_${YEAR_MONTH}.png`,
      pageSignal: '45 & 277 or 615 & 577',
      data: roomVideoMultiplexDual
    },
    roomVideoMultiplexQuad: {
      image: `${BASE_URL}/Room_Video_Multiplex_Quad_${YEAR_MONTH}.png`,
      pageSignal: '45 & 277 or 615 & 577',
      data: roomVideoMultiplexQuad
    },
    roomVideoMultiplexSingle: {
      image: `${BASE_URL}/Room_Video_Multiplex_Single_${YEAR_MONTH}.png`,
      pageSignal: '45 & 277 or 615 & 577',
      data: roomVideoMultiplexSingle
    },
    roomVideoRoku: {
      image: `${BASE_URL}/Room_Video_Roku_${YEAR_MONTH}.png`,
      pageSignal: '45 & 279 or 615 & 579',
      data: roomVideoRoku
    },
    roomVideoText: {
      image: `${BASE_URL}/Room_Video_Text_${YEAR_MONTH}.png`,
      pageSignal: '45 & 275 or 615 & 575',
      data: roomVideoText
    },
    systems: {
      image: `${BASE_URL}/Systems_${YEAR_MONTH}.png`,
      pageSignal: '23',
      data: systems
    },
    globalAudio: {
      image: `${BASE_URL}/Global_Audio_${YEAR_MONTH}.png`,
      pageSignal: '503',
      data: globalAudio
    },
    globalClimate: {
      image: `${BASE_URL}/Global_Climate_${YEAR_MONTH}.png`,
      pageSignal: '502',
      data: globalClimate
    },
    globalLights: {
      image: `${BASE_URL}/Global_Lights_${YEAR_MONTH}.png`,
      pageSignal: '501',
      data: globalLights
    },
    globalShades: {
      image: `${BASE_URL}/Global_Shades_${YEAR_MONTH}.png`,
      pageSignal: '506',
      data: globalShades
    },
    globalVideo: {
      image: `${BASE_URL}/Global_Video_${YEAR_MONTH}.png`,
      pageSignal: '504',
      data: globalVideo
    },
    securityCameras: {
      image: `${BASE_URL}/Security_Cameras_${YEAR_MONTH}.png`,
      pageSignal: '505',
      data: securityCameras
    },
    securitySystem: {
      image: `${BASE_URL}/Security_System_${YEAR_MONTH}.png`,
      pageSignal: '505',
      data: securitySystem
    },
    securityZones: {
      image: `${BASE_URL}/Security_Zones_${YEAR_MONTH}.png`,
      pageSignal: '505',
      data: securityZones
    },
    pool: {
      image: `${BASE_URL}/Pool_${YEAR_MONTH}.png`,
      pageSignal: '508 & Pool.Pool.Pool.Selected_fb',
      data: pool
    },
    spa: {
      image: `${BASE_URL}/Spa_${YEAR_MONTH}.png`,
      pageSignal: '508 & Pool.Pool.Spa.Selected_fb',
      data: spa
    },
    intercom: {
      image: `${BASE_URL}/Intercom_${YEAR_MONTH}.png`,
      // pageSignal: '507',
      data: intercomData
    },
    allSignals: {
      image: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjgwIiBoZWlnaHQ9IjgwMCI+CiAgPHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0iYmxhY2siLz4KPC9zdmc+",
      data: allSignals,
    }
};

export default pageConfigs;
